import Vue from 'vue'
import VueRouter from 'vue-router'
import * as types from '../store/types'
import store from '../store/index'

Vue.use(VueRouter)

const NewsMain = () => import('../components/NewsMain.vue')
const NewsSupport = () => import('../components/NewsSupport.vue')
const BaseHeader = () => import('../components/common/BaseHeader.vue')
const BaseFooter = () => import('../components/common/BaseFooter.vue')

if (window.localStorage.getItem(types.STORAGE_ACCESS_TOKEN)) {
  store.commit(types.USER_LOGIN, {
    access: window.localStorage.getItem(types.STORAGE_ACCESS_TOKEN),
    refresh: window.localStorage.getItem(types.STORAGE_REFRESH_TOKEN)
  })
}

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'NewsMain',
      components: {
        default: NewsMain,
        header: BaseHeader,
        footer: BaseFooter
      }
    },
    {
      path: '/support',
      name: 'NewsSupport',
      components: {
        default: NewsSupport,
        header: BaseHeader,
        footer: BaseFooter
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js